import Component, { mixins } from 'vue-class-component'

import WithRender from './NavigationBar.html'

@WithRender
@Component({})
export default class NavigationBar extends mixins() {}
